module.exports = __webpack_public_path__ + "static/img/invite1.aa926c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/invite1.png
// module id = 913
// module chunks = 1